import {createSelector} from "reselect";
import {State} from "../reducers";

const ForceOptionsState = (state: State) => state.search.forceSearchOptions;
export const attachedOnlySelected = createSelector(ForceOptionsState, state => state.attachedOnly)
export const pageSizeSelector = createSelector(ForceOptionsState, state => state.pageSize)
export const querySelector = createSelector(ForceOptionsState, state => state.query || "")
